import * as React from "react";
import {Tab} from "semantic-ui-react";
import {ReportScriptResults} from "./ReportScriptResults";
import {LogView} from "../../logView/LogView";
import {clampTabIndex} from "../../../context/TabSession";


const panes = [
    {menuItem: 'Results', render: props => <Tab.Pane>
            <ReportScriptResults
                response={props.response}
            />
    </Tab.Pane>},
    {
        menuItem: 'Logs', render: props => <Tab.Pane>
            <div style={{height:"500px"}}>
                <LogView
                    query={props.xRequestId}
                    origin={"reportScript"}
                    initialTimespan={null}
                    responseLogs={null}
                />
            </div>

        </Tab.Pane>
    },
]

const ReportScriptResultTabMenu = props => <Tab
    {...props = props}
    panes={panes}
    defaultActiveIndex={clampTabIndex(props.context.tabSession.reportScriptResultTab, panes)}
    onTabChange={(_, data) => {
        props.context.setSingleTabSession("reportScriptResultTab", data.activeIndex)
    }}
/>

export default ReportScriptResultTabMenu